import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, take, timer } from 'rxjs';
import { RoutingUtils } from 'src/app/utils';
import { ModalService } from '../view-components/modal.service';
import { TIMER_EXPIRED } from './session-time.constant';
import { SESSION_KEYS } from 'src/app/shared/constants/params.constant';
import { StorageService } from 'src/app/shared/service/storage.service';

@Injectable({
  providedIn: 'root'
})
export class SessionTimeService {
  constructor(private router: Router, private modalService: ModalService, private storageService: StorageService) {
    const exist = this.storageService.get(SESSION_KEYS.TIMERLOAD);
    const token = this.storageService.get(SESSION_KEYS.UUID);
    if (!exist && !token) {
      this.storageService.set(SESSION_KEYS.TIMERLOAD, JSON.stringify(new Date().getTime()))
    }
  }

  timerExpiredSession(): Observable<any> {
    return timer(0, 1000).pipe(take(this.calculateTimerFinish()));
  }

  calculateTimerFinish(): number {
    const dateTime = this.storageService.get(SESSION_KEYS.TIMERLOAD) || '';
    if (!dateTime) return 0;

    const distance = (new Date().getTime() - new Date(JSON.parse(dateTime)).getTime()) / 1000;
    return Math.round(TIMER_EXPIRED.expiredmessage.time - distance);
  }

  openNotificationExprired() {
    this.storageService.removeListKeys([SESSION_KEYS.UUID, SESSION_KEYS.SOCIO]);
    this.router.navigate([RoutingUtils.AtRoot(RoutingUtils.Routes.SESSION)]);
  }

  openNotificationPreExprired(): void {
    this.modalService.openModal(
      {
        isOpen: true,
        data: TIMER_EXPIRED.preexpiredmessage
      }
    ).subscribe();
  }
}
